// extracted by mini-css-extract-plugin
export default {"table":"booking_list___table___d0d6b4ca"};